"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var info = {
  $schema: '../assetlist.schema.json',
  chain_name: 'dydx',
  assets: [{
    description: 'The native staking token of dYdX Protocol.',
    denom_units: [{
      denom: 'adydx',
      exponent: 0
    }, {
      denom: 'dydx',
      exponent: 18
    }],
    base: 'adydx',
    name: 'dYdX',
    display: 'dydx',
    symbol: 'DYDX',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg'
    },
    coingecko_id: 'dydx',
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx.svg'
    }, {
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/dydx/images/dydx-circle.svg',
      theme: {
        circle: true
      }
    }],
    socials: {
      webiste: 'https://dydx.trade/',
      twitter: 'https://twitter.com/dYdX'
    }
  }, {
    description: 'Noble USDC on dYdX Protocol.',
    denom_units: [{
      denom: 'ibc/8E27BA2D5493AF5636760E354E46004562C46AB7EC0CC4C1CA14E9E20E2545B5',
      exponent: 0
    }, {
      denom: 'usdc',
      exponent: 6
    }],
    type_asset: 'ics20',
    base: 'ibc/8E27BA2D5493AF5636760E354E46004562C46AB7EC0CC4C1CA14E9E20E2545B5',
    name: 'Noble USDC',
    display: 'usdc',
    symbol: 'USDC',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'noble',
        base_denom: 'uusdc',
        channel_id: 'channel-33'
      },
      chain: {
        channel_id: 'channel-0',
        path: 'transfer/channel-0/uusdc'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'noble',
        base_denom: 'uusdc'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/USDCoin.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/USDCoin.svg'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/USDCoin.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/noble/images/USDCoin.svg'
    }
  }]
};
var _default = exports["default"] = info;